import _ from "lodash";
export const debounced = _.debounce((value, callBackFn) => {
  callBackFn && callBackFn(value);
}, 500);
